import Axios from 'axios';
import withAuthenticator from 'HOCs/withAuthenticator';
import ActiveCode from 'components/Error/ActiveCode';
import React from 'react';
import { useSelector } from 'react-redux';
import { Col, Row, Modal, ModalBody, Input, Button } from 'reactstrap';
import styles from './styles.module.css';

const BookActivationComponent = ({ loggedInUser, isOpen, toggle }) => {
  const token = loggedInUser?.accessToken ?? '';
  const config = {
    headers: { Authorization: `Bearer ${token}` },
  };

  const findBookByCode = () => {
    const bodyParameters = {
      bookCode: 'S101-1b77-8ec3-d2df',
      bookGroupId: 0,
      pageIndex: 1,
      pageSize: 12,
      classId: 0,
      totalPage: 1,
    };
    Axios.post('https://apihanhtrangso.nxbgd.vn/api/Book/GetBookByCode', bodyParameters, config)
      .then((res) => console.log(res))
      .catch((err) => console.log(err));
  };

  const activeBook = () => {
    const bodyParameters = {
      bookId: 417,
      activeCode: 'S101-667c-2743-0d31',
    };
    Axios.post('https://apihanhtrangso.nxbgd.vn/api/Book/ActiveBookById', bodyParameters, config)
      .then((res) => console.log(res))
      .catch((err) => console.log(err));
  };

  return (
    <Modal scrollable size='lg' contentClassName={styles.modalClassContent} className={`${styles.modalClassName}`} isOpen={isOpen} toggle={toggle}>
      <ModalBody className={styles.modalBodyClassName}>
        <Row className={`d-flex ${styles.header} flex-1`}>
          <Col className={styles.headerTitle}>Kích hoạt sách</Col>
        </Row>
        <Col className={`${styles.body}`}>
          <Row>
            <Col>
              <Row className={`m-3 ${styles.bodyTitle}`}>Nhập mã kích hoạt</Row>
              <Row style={{ padding: '0px 20px' }} className={`${styles.searching}`}>
                <Input className={`${styles.input}`} placeholder='Ví dụ: S012-123ac-4567-8d9f' />
                <div className={styles.buttonCover}>
                  <Button className={`${styles.searchButton}`} onClick={findBookByCode}>
                    Tìm kiếm
                  </Button>
                </div>
              </Row>
              <Row className={`${styles.content}`}>Sử dụng mã sách được cung cấp để kích hoạt sách.</Row>
            </Col>
          </Row>
          <Row style={{ margin: '0px 10px 10px 10px', displaty: 'flex' }}>
            <Col lg='3'>
              <img style={{ borderRadius: 10 }} width={160} height={250} src='https://downloadsach.com/wp-content/uploads/2018/03/101_buoc_ve_chi_can_ban_trong_hoi_hoa-227x300.jpg' alt='' />
            </Col>
            <Col lg='9'>
              <div style={{ marginBottom: 10 }}>
                <div style={{ fontSize: 15 }}>
                  <b>101 bước vẽ căn bản trong hội họa</b>
                </div>
                <div style={{ fontWeight: 600 }}>Robert Capitolo</div>
              </div>
              <div>
                Có thể nói, vẽ chì là môn căn bản nhất cho những ai yêu và học mỹ thuật đều phải nghiên cứu. Muốn có được bức họa đẹp và sinh động cần phải nắm vững kỹ thuật phân mảng và đánh bóng, sắc độ đậm nhạt của chất liệu chì, là
                phương tiện giúp cho bạn thỏa chí tái hiện lại thiên nhiên theo cảm xúc của mình.
              </div>
              <div className={`${styles.buttonCover}`}>
                <Button className={`${styles.activeButton}`}>Kích hoạt sách</Button>
              </div>
            </Col>
          </Row>
          <Row style={{ margin: '0px 10px 10px 10px', displaty: 'flex' }}>
            <Col lg='3'>
              <img style={{ borderRadius: 10 }} width={160} height={250} src='https://downloadsach.com/wp-content/uploads/2018/03/101_buoc_ve_chi_can_ban_trong_hoi_hoa-227x300.jpg' alt='' />
            </Col>
            <Col lg='9'>
              <div style={{ marginBottom: 10 }}>
                <div style={{ fontSize: 15 }}>
                  <b>101 bước vẽ căn bản trong hội họa</b>
                </div>
                <div style={{ fontWeight: 600 }}>Robert Capitolo</div>
              </div>
              <div>
                Có thể nói, vẽ chì là môn căn bản nhất cho những ai yêu và học mỹ thuật đều phải nghiên cứu. Muốn có được bức họa đẹp và sinh động cần phải nắm vững kỹ thuật phân mảng và đánh bóng, sắc độ đậm nhạt của chất liệu chì, là
                phương tiện giúp cho bạn thỏa chí tái hiện lại thiên nhiên theo cảm xúc của mình.
              </div>
              <div className={`${styles.buttonCover}`}>
                <Button className={`${styles.activeButton}`}>Kích hoạt sách</Button>
              </div>
            </Col>
          </Row>
        </Col>

        {/* <ActiveCode /> */}
      </ModalBody>
    </Modal>
  );
};

export default withAuthenticator(BookActivationComponent);
